import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./global.css";
import ReactGA from 'react-ga';
import Hotjar from '@hotjar/browser';
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-WKR9HBT6'
}

TagManager.initialize(tagManagerArgs)

const siteId = 3702500;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

const TRACKING_ID = "G-SM80E6DZDS"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
